import * as actionTypes from './actionTypes';
//----------------------------------------------------------------------------------------------------------------------
export const getMe = ()=>({
        type: actionTypes.CONTOUR_CLOUD_ME
    });
export const getMeSuccess = (profile)=>({
        type: actionTypes.CONTOUR_CLOUD_ME_SUCCESS,
        payload: {
            profile
        }
    });
export const getMeError = (error)=>({
        type: actionTypes.CONTOUR_CLOUD_ME_ERROR,
        error
    }); //----------------------------------------------------------------------------------------------------------------------
